import { useEffect, useState } from "react";
import { ENDPOINTS, getApiUrl } from "../common/endpoints";
import { Requests } from "../common/requests";

export const useDecks = () => {
  const [decks, setDecks] = useState<any[]>([]);

  useEffect(() => {
    const fetchDecks = async () => {
      const apiUrl = getApiUrl(`${ENDPOINTS.TAROT_LIST_DECKS}?limit=0`);
      try {
        const data = await Requests.get(apiUrl);
        if (Array.isArray(data)) setDecks(data);
      } catch (e) {}
    };
    fetchDecks();
  }, []);
  return {
    decks,
  };
};
